const PREFIX = "Shared/Application/";

export const RECEIVE_APPLICATIONS = `${PREFIX}RECEIVE_APPLICATIONS`;
export const RECEIVE_APPLICATION = `${PREFIX}RECEIVE_APPLICATION`;
